// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "5b8f06ad2ee3b70f274f" + ".js";
};